import { useEffect, useState } from "react"
import { User } from "../../../../shared/types/user"
import { getMe, getUsers } from "../../../../features/search/service/user-service"
import { MenuTop } from "../../../../components/menu/top/menu-top"
import "./styles/list.css"
import ButtonComponent from "../../../../components/button/button"
import { useNavigate } from "react-router-dom"
import Icons from "../../../../components/Icon/icons"
import { deleteUser } from "../../../../features/search/service/user-service"
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button
} from '@mui/material'
import { ConfirmDialog } from "../../../../components/modal/confirmation"

export const AdminUsersList = () => {
    const navigate = useNavigate();
    const [users, setUsers] = useState<User[]>([])
    const [me, setMe] = useState<User | null>(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState<string | null>(null)
    const [openDialog, setOpenDialog] = useState(false)
    const [userToDelete, setUserToDelete] = useState<User | null>(null)
    
    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true)
                setError(null)
                
                const [userData, usersData] = await Promise.all([
                    getMe(),
                    getUsers()
                ])
                
                setMe(userData)
                setUsers(usersData)
            } catch (error) {
                console.error('❌ Erro ao buscar dados:', error)
                setError('Não foi possível carregar os usuários')
            } finally {
                setLoading(false)
            }
        }
        
        fetchData()
    }, [])

    const handleOpenDialog = (user: User) => {
        setUserToDelete(user)
        setOpenDialog(true)
    }

    const handleCloseDialog = () => {
        setOpenDialog(false)
        setUserToDelete(null)
    }

    const handleConfirmDelete = async () => {
        if (!userToDelete?.id) return
        
        try {
            setLoading(true)
            setError(null)
            
            // await deleteUser(userToDelete.id)
            
            // const updatedUsers = users.filter((user) => user.id !== userToDelete.id)
            // setUsers(updatedUsers)
            
            handleCloseDialog()
        } catch (error) {
            console.error('❌ Erro ao deletar usuário:', error)
            setError('Não foi possível deletar o usuário')
        } finally {
            setLoading(false)
        }
    }

    if (loading) {
        return (
            <div className="admin-users-page">
                <MenuTop />
                <div className="users-loading">
                    <div className="users-loading-text">Carregando usuários...</div>
                </div>
            </div>
        )
    }

    if (error) {
        return (
            <div className="admin-users-page">
                <MenuTop />
                <div className="users-error">
                    <div className="users-error-text">{error}</div>
                </div>
            </div>
        )
    }

    return (
        <div className="admin-users-page">
            <MenuTop />
            <div className="users-container">
                {/* Header */}
                <div className="users-header">
                    <h1 className="users-title">Usuários</h1>
                    <p className="users-subtitle">
                        {users.length} {users.length === 1 ? 'usuário' : 'usuários'} cadastrado{users.length !== 1 && 's'}
                    </p>
                </div>

                {/* Lista de usuários */}
                <div className="users-grid">
                    {users.map((user) => (
                        <div key={user.id} className="user-card">
                            {/* Avatar e nome */}
                            <div className="user-card-header">
                                <div className="user-avatar">
                                    {user.name?.charAt(0).toUpperCase() || '?'}
                                </div>
                                <div className="user-info">
                                    <h3 className="user-name">
                                        {user.name}
                                    </h3>
                                    <p className="user-email">{user.email}</p>
                                </div>
                                <Icons 
                                    iconClicked={() => handleOpenDialog(user)} 
                                    iconName="DeleteOutline" 
                                    addTooltip="Deletar Usuário"
                                />
                            </div>

                            {/* Informações adicionais */}
                            <div className="user-details">
                                {user.role && (
                                    <div className="user-detail-row">
                                        <span className="user-detail-label">Função:</span>
                                        <span className="user-detail-value user-role">
                                            {user.role.name}
                                        </span>
                                    </div>
                                )}
                            </div>

                            {/* Ações */}
                            <div className="user-card-footer">
                                <ButtonComponent
                                    label="Ver detalhes"
                                    onClick={() => navigate(`/admin-painel/users/edit/${user.id}`)}
                                />
                            </div>
                        </div>
                    ))}
                </div>

                {/* Empty state */}
                {users.length === 0 && (
                    <div className="users-empty">
                        <div className="users-empty-text">
                            Nenhum usuário encontrado
                        </div>
                    </div>
                )}
            </div>

            <ConfirmDialog
                open={openDialog}
                title="Deletar usuário"
                message={`Tem certeza que deseja deletar <strong>${userToDelete?.name}</strong>? Esta ação não pode ser desfeita.`}
                confirmText="Deletar"
                cancelText="Cancelar"
                onConfirm={handleConfirmDelete}
                onCancel={handleCloseDialog}
                confirmColor="error"
                loading={loading}
            />
        </div>
    )
}